import { useEffect } from "react";

export function useSecretCode(code: string, onMatch: () => void) {
  useEffect(() => {
    let buffer = "";
    const handler = (e: KeyboardEvent) => {
      const el = e.target as HTMLElement | null;
      if (el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable)) return;
      if (e.key.length !== 1) return;
      buffer = (buffer + e.key).slice(-code.length);
      if (buffer === code) {
        buffer = "";
        onMatch();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [code, onMatch]);
}
